<template>
  <div class="basic-profile-container" ref="faultTree">
    <div style="text-align: right; margin-bottom: 10px">
      <!--      <div style="display: inline-block; margin-right: 20px">
        <customize-button
          v-if="!isAllEdit"
          type="primary"
          @click="handleAllEdit"
        >
          Edit
        </customize-button>
        <template v-else>
          <customize-button style="margin-right: 20px" @click="handleAllCancel">
            Cancel
          </customize-button>
          <customize-button @click="handleAllSave" type="primary">
            Save
          </customize-button>
        </template>
      </div>-->
      <customize-button type="primary" @click="generatePDF">
        Generate PDF
      </customize-button>
    </div>
    <!--Customer Information-->
    <el-card shadow="never" class="mt-24">
      <div slot="header" class="cart-header-wrapper">
        <span class="title">Customer Information</span>
        <div class="action">
          <template v-if="isShowCustomerInfoForm">
            <customize-button
              style="margin-right: 20px"
              @click="isShowCustomerInfoForm = false"
            >
              Cancel
            </customize-button>
            <customize-button type="primary" @click="handleCustomerInfoSaveBtn">
              Save
            </customize-button>
          </template>
          <customize-button
            v-else
            type="primary"
            @click="isShowCustomerInfoForm = true"
          >
            Edit
          </customize-button>
        </div>
      </div>
      <!-- trade -->
      <customize-form
        v-if="$store.state.source === 1"
        ref="customerInfo"
        :is-show-form="isShowCustomerInfoForm"
        :model="customerInfo.base || {}"
        :schema="customerInfoSchema"
      />
      <!-- CSS -->
      <customize-form
        v-if="$store.state.source === 2"
        ref="customerInfo"
        :is-show-form="isShowCustomerInfoForm"
        :model="customerInfo.base || {}"
        :schema="customerInfoSchema2"
      />
    </el-card>

    <!--External Reference Information-->
    <el-card shadow="never" class="mt-24" style="display: none">
      <div slot="header" class="cart-header-wrapper">
        <span class="title">External Reference Information</span>
        <div class="action">
          <template v-if="isShowExternalReferenceInfoForm">
            <customize-button
              style="margin-right: 20px"
              @click="isShowExternalReferenceInfoForm = false"
            >
              Cancel
            </customize-button>
            <customize-button
              type="primary"
              @click="handleExternalReferenceInfoSaveBtn"
            >
              Save
            </customize-button>
          </template>
          <customize-button
            v-else
            type="primary"
            @click="isShowExternalReferenceInfoForm = true"
          >
            Edit
          </customize-button>
        </div>
      </div>
      <customize-form
        ref="externalReferenceInfo"
        :is-show-form="isShowExternalReferenceInfoForm"
        :model="customerInfo.base || {}"
        :schema="externalReferenceInfoSchema"
      />
    </el-card>
    <!--EaaS Information-->
    <el-card shadow="never" class="mt-24" v-if="customerType === 'Eaas'">
      <div slot="header" class="cart-header-wrapper">
        <span class="title">EaaS Information</span>
        <div class="action">
          <template v-if="isShowEaasInformationForm">
            <customize-button
              style="margin-right: 20px"
              @click="isShowEaasInformationForm = false"
            >
              Cancel
            </customize-button>
            <customize-button
              type="primary"
              @click="handleEaasInformationSaveBtn"
            >
              Save
            </customize-button>
          </template>
          <customize-button
            v-else
            type="primary"
            @click="isShowEaasInformationForm = true"
          >
            Edit
          </customize-button>
        </div>
      </div>
      <customize-form
        ref="eaasInformation"
        :is-show-form="isShowEaasInformationForm"
        :model="customerInfo.base || {}"
        :schema="eaasInformationSchema"
      />
    </el-card>
    <!--Account Management-->
    <el-card shadow="never" class="mt-24">
      <div slot="header" class="cart-header-wrapper">
        <span class="title">Account Management</span>
        <div class="action">
          <template v-if="isShowAccountManagementForm">
            <customize-button
              style="margin-right: 20px"
              @click="isShowAccountManagementForm = false"
            >
              Cancel
            </customize-button>
            <customize-button
              type="primary"
              @click="handleAccountManagementSaveBtn"
            >
              Save
            </customize-button>
          </template>
          <customize-button
            v-else
            type="primary"
            @click="isShowAccountManagementForm = true"
          >
            Edit
          </customize-button>
        </div>
      </div>
      <customize-form
        ref="accountManagement"
        :is-show-form="isShowAccountManagementForm"
        :model="account || {}"
        :schema="accountManagementSchema"
      />
    </el-card>

    <!--Japan-->
    <el-card
      shadow="never"
      class="mt-24"
      v-if="customerInfo.base && customerInfo.base.countryStr === 'Japan'"
    >
      <div slot="header" class="cart-header-wrapper">
        <span class="title">Japan</span>
        <div class="action">
          <template v-if="isShowJapanForm">
            <customize-button
              style="margin-right: 20px"
              @click="isShowJapanForm = false"
            >
              Cancel
            </customize-button>
            <customize-button type="primary" @click="handleJapanSaveBtn">
              Save
            </customize-button>
          </template>
          <customize-button
            v-else
            type="primary"
            @click="isShowJapanForm = true"
          >
            Edit
          </customize-button>
        </div>
      </div>
      <customize-form
        ref="japan"
        :is-show-form="isShowJapanForm"
        :model="customerInfo.companyJapanDetail || {}"
        :schema="japanSchema"
      />
    </el-card>

    <!--Additional Information-->
    <el-card shadow="never" class="mt-24">
      <div slot="header" class="cart-header-wrapper">
        <span class="title">Additional Information</span>
        <div class="action">
          <template v-if="isShowAddInfoForm">
            <customize-button
              style="margin-right: 20px"
              @click="isShowAddInfoForm = false"
            >
              Cancel
            </customize-button>
            <customize-button type="primary" @click="handleAddInfoSaveBtn">
              Save
            </customize-button>
          </template>
          <customize-button
            v-else
            type="primary"
            @click="isShowAddInfoForm = true"
          >
            Edit
          </customize-button>
        </div>
      </div>
      <customize-form
        ref="addInfo"
        :is-show-form="isShowAddInfoForm"
        :model="customerInfo.detail || {}"
        :schema="addInfoSchema"
      />
    </el-card>

    <!--Business Contacts-->
    <el-card shadow="never" class="mt-24" v-if="false">
      <div slot="header" class="cart-header-wrapper">
        <span class="title">Business Contacts</span>
        <div class="action">
          <template v-if="isShowBusinessContactsForm">
            <customize-button
              style="margin-right: 20px"
              @click="isShowBusinessContactsForm = false"
            >
              Cancel
            </customize-button>
            <customize-button
              type="primary"
              @click="handleBusinessContactsSaveBtn"
            >
              Save
            </customize-button>
          </template>
          <customize-button
            v-else
            type="primary"
            @click="isShowBusinessContactsForm = true"
          >
            Edit
          </customize-button>
        </div>
      </div>
      <customize-form
        ref="businessContacts"
        :is-show-form="isShowBusinessContactsForm"
        :model="customerInfo.shareholder || {}"
        :schema="businessContactsSchema"
      />
    </el-card>
  </div>
</template>

<script>
import { getSelectList } from '@/api'
import {
  getCurrencyList,
  getCustomerInfo,
  addOrUpdateExternalInfo,
  addOrUpdateAccountInfo,
  addOrUpdateJapanInfo,
  vagueActiveName,
  addOrUpdateEaasInformation,
} from './api'
import basicMixin from './pages/basic'
import detailMixin from './pages/detail'
import businessMixin from './pages/business'
import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'

const selectList = [
  'Country',
  'Region',
  'CCA',
  'Business',
  'Geo',
  'SalesCountry',
  'BU',
]

export default {
  mixins: [basicMixin, detailMixin, businessMixin],
  data() {
    const customerInfoSchema2 = [
      {
        label: 'Customer #',
        type: 'Despace',
        key: 'code',
      },
      {
        label: 'Customer Name',
        type: 'input',
        key: 'name',
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
      },
      {
        label: 'Currency',
        type: 'select',
        placeholder: 'All',
        key: 'currency',
        selectList: [],
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
      },
      {
        label: 'Business Type',
        type: 'select',
        placeholder: 'All',
        key: 'business',
        selectList: [],
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
      },
      {
        label: 'GEO',
        type: 'select',
        placeholder: 'All',
        key: 'geo',
        selectList: [],
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        change: this.handleGeoSelectChange,
      },
      {
        label: 'Region',
        type: 'select',
        placeholder: 'All',
        key: 'region',
        selectList: [],
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        change: this.handleRegionChange,
      },
      {
        label: 'Payment Term(Day)',
        type: 'input',
        key: 'paymentTermReq',
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
          {
            min: 0,
            max: 200,
            message: 'No more than 200 characters.',
            trigger: 'blur',
          },
        ],
      },
      {
        label: 'Registration Country',
        type: 'select',
        placeholder: 'All',
        key: 'country',
        selectList: [],
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
      },
      {
        label: 'CCA',
        type: 'select',
        placeholder: 'All',
        key: 'cca',
        selectList: [],
        change: this.handleCcaChange,
      },
      {
        label: 'Sub-Region',
        type: 'input',
        key: 'subRegion',
      },
      {
        label: 'State',
        type: 'input',
        key: 'state',
      },
      {
        label: 'Source',
        type: 'select',
        placeholder: 'All',
        key: 'source',
        disabled: true,
        selectList: [
          { id: 1, name: 'Lenovo' },
          { id: 2, name: 'CSS' },
        ],
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
      },
      {
        label: 'City',
        type: 'input',
        key: 'city',
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
      },
      {
        label: 'Duns #',
        type: 'input',
        key: 'dunsNo',
      },
      {
        label: 'Address',
        type: 'input',
        key: 'address',
        rules: [
          { required: true, message: 'Can not be empty!', trigger: 'blur' },
        ],
      },
      {
        label: 'Phone',
        type: 'input',
        key: 'mobile',
      },
      {
        label: 'ZIP Code',
        type: 'input',
        key: 'zipCode',
      },
      {
        label: 'In Business Since',
        type: 'date',
        key: 'registerDate',
      },
      {
        label: 'Year With Lenovo Since',
        type: 'date',
        key: 'signDate',
      },
      {
        label: 'Sold to #',
        type: 'input',
        key: 'soldPartyNo',
      },
      {
        label: 'National Registration # or VAT #',
        type: 'input',
        key: 'registeredNo',
      },
      {
        label: 'LINK ID',
        type: 'input',
        key: 'linkId',
      },

      {
        label: 'Risk Category in SAP',
        type: 'select',
        key: 'sapRiskType',
        placeholder: 'All',
        selectList: [
          {
            id: '001',
            name: '001',
          },
          {
            id: '002',
            name: '002',
          },
          {
            id: '003',
            name: '003',
          },
          {
            id: '004',
            name: '004',
          },
          {
            id: '005',
            name: '005',
          },
          {
            id: '006',
            name: '006',
          },
          {
            id: '999',
            name: '999',
          },
        ],
      },
      {
        label: 'Hierarchy Level',
        type: 'select',
        key: 'hierarchyLevel',
        placeholder: 'All',
        disabled: true,
        selectList: [
          {
            id: 1,
            name: 'Parent',
          },
          {
            id: 2,
            name: 'Subsidiary',
          },
        ],
      },
      {
        label: 'Sales Country',
        type: 'select',
        key: 'salesCountry',
        placeholder: 'All',
        selectList: [],
      },
      {
        label: 'BU',
        type: 'select',
        key: 'bu',
        placeholder: 'All',
        selectList: [],
      },
    ]
    const externalReferenceInfoSchema = [
      {
        label: 'Social Security #',
        type: 'input',
        key: 'socialSecurityNo',
      },
      {
        label: 'Tax ID',
        type: 'input',
        key: 'taxId',
      },
      {
        label: 'Experian BIN',
        type: 'input',
        key: 'experianBin',
      },
    ]
    const accountManagementSchema = [
      {
        label: 'Account Status #',
        type: 'select',
        key: 'accountStatus',
        selectList: [
          { id: 1, name: 'Active' },
          { id: 2, name: 'High Risk' },
          { id: 3, name: 'Inactive' },
          { id: 4, name: 'On Hold' },
        ],
      },
      {
        label: 'My Quick View',
        type: 'checkbox',
        key: 'myWatchList',
      },
      // {
      //   label: 'Credit Analyst',
      //   type: 'select',
      //   placeholder: 'All',
      //   key: 'creditManager',
      //   selectList: [],
      //   remoteMethod: this.remoteActiveName,
      // },
      // {
      //   label: 'Financial Format',
      //   type: 'select',
      //   placeholder: 'All',
      //   key: 'financialFormat',
      //   selectList: [
      //     { id: 1, name: 'Lenovo Financials' },
      //     { id: 2, name: 'US Long' },
      //   ],
      // },
      {
        label: 'IRFS dealer code',
        type: 'input',
        style: { display: 'none' },
        key: 'irfsDealerCode',
      },
    ]
    const japanSchema = [
      {
        label: 'Japan: Customer Name in English',
        type: 'input',
        key: 'customerNameEnglish',
      },
      {
        label: 'Japan: Latest Financial Year Total Profit', //千分位
        type: 'input',
        key: 'latestFYTotalProfit',
      },
      {
        label: 'Japan: Latest Financial Year Total Revenue', //千分位
        type: 'input',
        key: 'latestFYTotalRevenue',
      },
      {
        label: 'Japan: Latest Financial Date',
        type: 'date',
        key: 'latestFDate',
      },
      {
        label: 'Japan: TDB Rating',
        type: 'input',
        key: 'tdbRating',
      },
      {
        label: 'Japan: Total Overdue AMT >= 60 Days',
        type: 'input',
        key: 'totalOverdueAmt60',
      },
      {
        label: 'Japan: Latest Financial Year Total Capital', //千分位
        type: 'input',
        key: 'latestFYTotalCapital',
      },
    ]

    return {
      externalReferenceInfoSchema,
      accountManagementSchema,
      customerInfoSchema2,
      japanSchema,
      customerInfo: {},
      isShowExternalReferenceInfoForm: false,
      isShowAccountManagementForm: false,
      isShowJapanForm: false,
      itCodeList: [],
      isAllEdit: false,
      eaasInformationSchema: [
        {
          label: 'Contract Number',
          type: 'input',
          key: 'contractNum',
        },
        {
          label: 'Opportunity Number',
          type: 'input',
          key: 'oppNum',
        },
        {
          label: 'Business Model',
          type: 'select',
          placeholder: 'All',
          key: 'businessModel',
          selectList: [
            { id: 1, name: 'Sell to' },
            { id: 2, name: 'Sell with' },
            { id: 3, name: 'Sell Through' },
            { id: 4, name: 'Direct' },
            { id: 5, name: 'Indirect' },
          ],
        },
      ],
      isShowEaasInformationForm: false,
    }
  },
  computed: {
    account() {
      const result = { ...this.customerInfo.account }
      this.itCodeList.map(item => {
        if (item.id === result.creditManager) {
          result.creditManagerStr = item.username
        }
      })
      result.myWatchList = result.myWatchList === 1
      return result
    },
    customerType() {
      return this.$store.state.customerType
    },
  },
  created() {
    this.remoteActiveName()
    this.getAllSelect()
  },
  async mounted() {
    await this._getCurrencyList()
    await this._getCustomerInfo()
    // 需要select联动的时候,在第一次进来页面的时候没做处理
    // 例如:region选择North America; Country和sales country在第一次进来的时候应该只有united states
    await this._handleSelect()
    await this.handleRegistraCountry(this.customerInfo.base.country)
  },
  methods: {
    handleCcaChange(value) {
      console.log(value)
    },
    handleAllEdit() {
      this.isAllEdit = !this.isAllEdit
      this.isShowCustomerInfoForm = true
      this.isShowAccountManagementForm = true
      this.isShowAddInfoForm = true
      this.isShowBusinessContactsForm = true
      if (this.customerInfo?.base?.countryStr === 'Japan') {
        this.isShowJapanForm = true
      }
    },
    handleAllCancel() {
      this.isAllEdit = !this.isAllEdit
      this.isShowCustomerInfoForm = false
      this.isShowAccountManagementForm = false
      this.isShowAddInfoForm = false
      this.isShowBusinessContactsForm = false

      if (this.customerInfo?.base?.countryStr === 'Japan') {
        this.isShowJapanForm = false
      }
    },
    async handleAllSave() {
      try {
        await this.handleCustomerInfoSaveBtn()
        await this.handleAccountManagementSaveBtn()
        await this.handleAddInfoSaveBtn()
        await this.handleBusinessContactsSaveBtn()
        if (this.customerInfo?.base?.countryStr === 'Japan') {
          await this.handleJapanSaveBtn()
        }
        await this._getCustomerInfo()
        this.$message.success('success')
        this.isAllEdit = !this.isAllEdit
      } catch (e) {
        console.log(e)
      }
    },
    generatePDF() {
      let ref = this.$refs.faultTree // 截图区域
      const title = 'default'
      html2canvas(ref, {
        backgroundCoplor: '#f4f3f9',
      })
        .then(canvas => {
          let contentWidth = canvas.width
          let contentHeight = canvas.height
          let pageHeight = (contentWidth / 592.28) * 841.89
          let leftHeight = contentHeight
          let position = 0
          let imgWidth = 595.28
          let imgHeight = (592.28 / contentWidth) * contentHeight
          let pageData = canvas.toDataURL('image/jpeg', 1.0)
          let PDF = new JsPDF('', 'pt', 'a4')
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
              leftHeight -= pageHeight
              position -= 841.89
              if (leftHeight > 0) {
                PDF.addPage()
              }
            }
          }
          PDF.save(title + '.pdf')
        })
        .catch(() => {
          this.$message({
            message: 'Images generated failure',
            type: 'error',
          })
        })
    },
    // 模糊查询active name
    async remoteActiveName() {
      try {
        this.itCodeList = await vagueActiveName()
        this.accountManagementSchema[2].selectList = this.itCodeList.map(
          item => ({
            id: item.id,
            name: item.username,
            value: item.username,
          }),
        )
      } catch (err) {
        console.log(err)
      }
    },
    getAllSelect() {
      const pro = selectList.map(item => this._getSelectList(item))
      Promise.all(pro)
        .then(res => {
          if (res.length === selectList.length) {
            const [
              countryList,
              regionList,
              ccaList,
              businessList,
              geoList,
              SalesCountryList,
              BuList,
            ] = res
            console.log(SalesCountryList)
            // Business Contacts
            for (let i = 0; i < this.businessContactsSchema.length; i++) {
              const item = this.businessContactsSchema[i]
              if (item.label === 'Registration Country') {
                item['selectList'] = countryList
              }
            }
            // 基本信息
            for (let i = 0; i < this.customerInfoSchema.length; i++) {
              const item = this.customerInfoSchema[i]
              if (item.label === 'Region') {
                item['selectList'] = regionList
              } else if (item.label === 'Registration Country') {
                item['selectList'] = countryList
              } else if (item.label === 'CCA') {
                item['selectList'] = ccaList
              } else if (item.label === 'Business Type') {
                item['selectList'] = businessList
              } else if (item.label === 'GEO') {
                item['selectList'] = geoList
              } else if (item.key === 'salesCountry') {
                item['selectList'] = countryList
              } else if (item.key === 'bu') {
                item['selectList'] = BuList
              }
            }
            for (let i = 0; i < this.customerInfoSchema2.length; i++) {
              const item = this.customerInfoSchema2[i]
              if (item.label === 'Region') {
                item['selectList'] = regionList
              } else if (item.label === 'Registration Country') {
                item['selectList'] = countryList
              } else if (item.label === 'CCA') {
                item['selectList'] = ccaList
              } else if (item.label === 'Business Type') {
                item['selectList'] = businessList
              } else if (item.label === 'GEO') {
                item['selectList'] = geoList
              } else if (item.key === 'salesCountry') {
                item['selectList'] = countryList
              } else if (item.key === 'bu') {
                item['selectList'] = BuList
              }
            }
            this.isAllLoad = false
          }
        })
        .catch(err => {
          console.error(`search 列表查询错误:${err}`)
        })
    },
    async _getSelectList(typeMark) {
      try {
        return await getSelectList(typeMark)
      } catch (err) {
        console.error(err)
      }
    },
    async _getCurrencyList() {
      try {
        const data = await getCurrencyList()
        for (let i = 0; i < this.customerInfoSchema.length; i++) {
          const item = this.customerInfoSchema[i]
          if (item.label === 'Currency') {
            item['selectList'] = data.map(item => ({
              name: item.currencyName,
              id: item.currency,
            }))
          }
        }
        for (let i = 0; i < this.customerInfoSchema2.length; i++) {
          const item = this.customerInfoSchema2[i]

          if (item.label === 'Currency') {
            item['selectList'] = data.map(item => ({
              name: item.currencyName,
              id: item.currency,
            }))
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    async _getCustomerInfo() {
      try {
        this.customerInfo = await getCustomerInfo(this.$route.params.customerId)

        for (const key in this.customerInfo?.base) {
          // if (key === 'customerType') {
          //   this.customerInfo.base['customerTypeStr'] = this.customerInfoSchema
          //     .find(item => item.key === 'customerType')
          //     .selectList.find(
          //       item => item.id === this.customerInfo?.base[key],
          //     )?.name
          // }

          if (key === 'businessModel') {
            this.customerInfo.base['businessModelStr'] =
              this.eaasInformationSchema
                .find(item => item.key === 'businessModel')
                .selectList.find(
                  item => item.id === this.customerInfo?.base[key],
                )?.name
          }

          if (key === 'publicSentiment') {
            this.customerInfo.base['publicSentimentStr'] =
              this.customerInfoSchema
                .find(item => item.key === 'publicSentiment')
                .selectList.find(
                  item => item.id === this.customerInfo?.base[key],
                )?.name
          }
        }
        if (this.$store.state.source === 2) {
          this.accountManagementSchema = this.accountManagementSchema.filter(
            item => {
              if (item.key === 'irfsDealerCode') {
                item.style.display = 'block'
              }
              return item
            },
          )
        }
        //给Additional Information中设置千位符
        const filterAI = [
          'netWorth',
          'totalNetWorthCapital',
          'revenueLenovoLast12',
          'workingCapital',
          'overdueAmount60',
          'groupTotalApprovedLimit',
          'sumArBacklogAmount',
          'totalEmployees',
        ]
        filterAI.forEach(key => {
          const value = this.customerInfo.detail[key]
          this.customerInfo.detail[key] = this.$utils.formatAmount(value)
        })
        this.customerInfo.detail.moodys === 23
          ? (this.customerInfo.detail.moodys =
              this.customerInfo.detail.moodysStr)
          : this.customerInfo.detail.moodys
        this.customerInfo.detail.sp === 23
          ? (this.customerInfo.detail.sp = this.customerInfo.detail.spStr)
          : this.customerInfo.detail.sp
        this.customerInfo.detail.fitch === 23
          ? (this.customerInfo.detail.fitch = this.customerInfo.detail.fitchStr)
          : this.customerInfo.detail.fitch
        // japan 设置千位符
        const filterJapan = [
          'latestFYTotalProfit',
          'totalOverdueAmt60',
          'latestFYTotalRevenue',
          'latestFYTotalCapital',
          'overdueAmount60',
          'groupTotalApprovedLimit',
          'sumArBacklogAmount',
        ]
        filterJapan.forEach(key => {
          const value = this.customerInfo.companyJapanDetail[key]
          this.customerInfo.companyJapanDetail[key] =
            this.$utils.formatAmount(value)
        })
      } catch (err) {
        console.error(err)
      }
    },
    async handleExternalReferenceInfoSaveBtn() {
      try {
        const params = this.$refs.externalReferenceInfo.getFormData()
        await addOrUpdateExternalInfo({
          ...params,
          companyId: this.customerInfo.base.id,
        })
        this.$message.success('success')
        this.isShowExternalReferenceInfoForm = false
        await this._getCustomerInfo()
      } catch (err) {
        console.error(err)
        return Promise.reject(err)
      }
    },
    async handleEaasInformationSaveBtn() {
      try {
        const { businessModel, contractNum, oppNum } =
          this.$refs.eaasInformation.getFormData()

        await addOrUpdateEaasInformation({
          businessModel,
          contractNum,
          oppNum,
          id: this.customerInfo.base.id,
        })
        this.isShowEaasInformationForm = false
        await this._getCustomerInfo()
      } catch (err) {
        console.error(err)
        return Promise.reject(err)
      }
    },

    async handleAccountManagementSaveBtn() {
      try {
        const params = this.$refs.accountManagement.getFormData()
        params.myWatchList = params.myWatchList ? 1 : 2
        await addOrUpdateAccountInfo({
          ...params,
          companyId: this.customerInfo.base.id,
        })
        this.isShowAccountManagementForm = false
        await this._getCustomerInfo()
      } catch (err) {
        console.error(err)
        return Promise.reject(err)
      }
    },
    async handleJapanSaveBtn() {
      try {
        const params = this.$refs.japan.getFormData()
        params.latestFYTotalCapital = this.$utils.resetAmount(
          params.latestFYTotalCapital,
        )
        params.latestFYTotalProfit = this.$utils.resetAmount(
          params.latestFYTotalProfit,
        )
        params.latestFYTotalRevenue = this.$utils.resetAmount(
          params.latestFYTotalRevenue,
        )
        params.totalOverdueAmt60 = this.$utils.resetAmount(
          params.totalOverdueAmt60,
        )
        await addOrUpdateJapanInfo({
          ...params,
          companyId: this.customerInfo.base.id,
        })
        this.isShowJapanForm = false
        await this._getCustomerInfo()
      } catch (err) {
        console.error(err)
        return Promise.reject(err)
      }
    },
    async _handleSelect() {
      // region
      const res0 = await this._getSelectList({
        typeMark: 'Region',
        pid: this.customerInfo.base.geo,
      })
      for (let i = 0; i < this.customerInfoSchema.length; i++) {
        const item = this.customerInfoSchema[i]
        if (item.label === 'Region') {
          item['selectList'] = res0
        }
      }
      for (let i = 0; i < this.customerInfoSchema2.length; i++) {
        const item = this.customerInfoSchema2[i]
        if (item.label === 'Region') {
          item['selectList'] = res0
        }
      }
      // sales country
      const res2 = await this._getSelectList({
        typeMark: 'Country',
        pid: this.customerInfo.base.region,
      })
      for (let i = 0; i < this.customerInfoSchema.length; i++) {
        const item = this.customerInfoSchema[i]
        if (item.label === 'Sales Country') {
          item['selectList'] = res2
        }
      }
      for (let i = 0; i < this.customerInfoSchema2.length; i++) {
        const item = this.customerInfoSchema2[i]
        if (item.label === 'Sales Country') {
          item['selectList'] = res2
        }
      }
    },
    handleNeededSelect() {},
  },
}
</script>
